export default __webpack_public_path__ + "static/media/inactive_edit_icon.6e5de78a.svg";